import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="p-6 max-w-2xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">Something went wrong.</h2>
          {this.state.error && (
            <>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Error: {this.state.error.message || 'An unknown error occurred'}
              </p>
              {this.state.error.stack && (
                <details className="mb-4">
                  <summary className="cursor-pointer text-blue-600 dark:text-blue-400">Click for stack trace</summary>
                  <pre className="mt-2 p-4 bg-gray-100 dark:bg-gray-700 rounded-lg overflow-x-auto">
                    {this.state.error.stack}
                  </pre>
                </details>
              )}
            </>
          )}
          <p className="text-gray-600 dark:text-gray-400">
            Please try refreshing the page or contact support if the issue persists.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
